const ca_cochesnet = {
  POWERED_BY: "Servei ofert per",
};

export default ca_cochesnet;
